import { create } from 'zustand';
import type { User } from '../../data/domains/profile';

export type { User } from '../../data/domains/profile';

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isReady: boolean;
  setUser: (user: User) => void;
  clearUser: () => void;
  setReady: (ready: boolean) => void;
}

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  isAuthenticated: false,
  isReady: false,

  setUser: user => set({ user, isAuthenticated: !!user.session_token, isReady: true }),

  clearUser: () => set({ user: null, isAuthenticated: false, isReady: true }),

  setReady: ready => set({ isReady: ready }),
}));

export function getAuthStore(): AuthState {
  return useAuthStore.getState();
}
